import { ReactNode } from 'react';
import { css } from '@emotion/react';

export const FormControlError = ({ children }: { children: ReactNode }) => {
	return (
		<div
			css={css`
				width: 100%;
				font-size: 13px;
				line-height: 16px;
				font-weight: 600;
				color: #ff6767;
				padding-top: 8px;
			`}
		>
			{children}
		</div>
	);
};
